import 'react-native-gesture-handler';
import { registerRootComponent } from 'expo';
import * as SplashScreen from 'expo-splash-screen';
SplashScreen.preventAutoHideAsync()
  .then((result) => console.debug(`preventAutoHideAsync succeeded: ${result}`))
  .catch(console.warn);

import App from './App';

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
